import { CONSTANTS } from "src/app/constants";
import { IAnalyzer } from "../interfaces/analyzer.interface";

export class Analyzer implements IAnalyzer {
  analyzerpk: number;
  analyzerId: string;
  analyzermodelName: string;
  analyzermodelGas: string;
  telemetrysuppliername: string;
  exatmclasse: string;
  exatmregulation: string;
  fieldprotocolName: string;
  gatewayId: string;
  deletionFlag?: boolean | null;

  constructor(analyzer: IAnalyzer) {
    Object.keys(analyzer).map(key => this[key] = analyzer[key]);
  }

  get isActivated(): boolean {
    return this.deletionFlag !== true
  }

  get isNoAnalyzer(): boolean {
    return this.analyzerId.includes(CONSTANTS.EQUIPMENTS.NO_ANALYZER);
  }
}